import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDDisplayDateMonth } from '../Displayers/TEDDisplayDateMonth';
import { TEDParseDateMonth } from '../Parsers/TEDParseDateMonth';
class TEDFormatDateMonth implements IFormatter {
  displayer = TEDDisplayDateMonth.getInstance();
  parser = TEDParseDateMonth.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatDateMonth };
